const override = false;
const config = {
    development: {
        MEDIA_SERVICE_URL: 'https://staging.backend.leadconnectorhq.com/medias',
    },
    staging: {
        MEDIA_SERVICE_URL: 'https://staging.backend.leadconnectorhq.com/medias',
    },
    production: {
        MEDIA_SERVICE_URL: 'https://backend.leadconnectorhq.com/medias',
    },
};
if (override) {
    // do overrides here
}
export default config[process.env.mode];
